import React from 'react';
import {
  BarChart3, Lightbulb, Cloud, MessageSquare, Star,
  Target, ClipboardCheck, FileText, Puzzle
} from 'lucide-react';

const sizeMap = {
  sm: 20,
  md: 24,
  lg: 28,
  xl: 32,
};

const PollIcon = ({ size = 'lg' }) => <BarChart3 size={sizeMap[size]} strokeWidth={1.75} />;
const QuizIcon = ({ size = 'lg' }) => <Lightbulb size={sizeMap[size]} strokeWidth={1.75} />;
const WordCloudIcon = ({ size = 'lg' }) => <Cloud size={sizeMap[size]} strokeWidth={1.75} />;
const QnAIcon = ({ size = 'lg' }) => <MessageSquare size={sizeMap[size]} strokeWidth={1.75} />;
const FeedbackIcon = ({ size = 'lg' }) => <Star size={sizeMap[size]} strokeWidth={1.75} />;
const ChallengesIcon = ({ size = 'lg' }) => <Target size={sizeMap[size]} strokeWidth={1.75} />;
const ActionPlansIcon = ({ size = 'lg' }) => <ClipboardCheck size={sizeMap[size]} strokeWidth={1.75} />;
const OpenQuestionIcon = ({ size = 'lg' }) => <FileText size={sizeMap[size]} strokeWidth={1.75} />;
const DefaultIcon = ({ size = 'lg' }) => <Puzzle size={sizeMap[size]} strokeWidth={1.75} />;

const iconComponents = {
  poll: PollIcon,
  quiz: QuizIcon,
  word_cloud: WordCloudIcon,
  wordcloud: WordCloudIcon,
  qna: QnAIcon,
  qa: QnAIcon,
  feedback: FeedbackIcon,
  challenges: ChallengesIcon,
  actionplans: ActionPlansIcon,
  actionPlans: ActionPlansIcon,
  openquestion: OpenQuestionIcon,
  open_question: OpenQuestionIcon,
};

export const getActivityIcon = (type, size = 'lg') => {
  const normalizedType = type?.toLowerCase();
  const IconComponent = iconComponents[normalizedType] || iconComponents[type] || DefaultIcon;
  return <IconComponent size={size} />;
};

export const getActivityTypeColor = (type) => {
  const colorMap = {
    poll: 'bg-purple-50 text-purple-600',
    quiz: 'bg-amber-50 text-amber-600',
    word_cloud: 'bg-teal-50 text-teal-600',
    wordcloud: 'bg-teal-50 text-teal-600',
    qna: 'bg-blue-50 text-blue-600',
    qa: 'bg-blue-50 text-blue-600',
    feedback: 'bg-orange-50 text-orange-500',
    challenges: 'bg-rose-50 text-rose-600',
    actionplans: 'bg-sky-50 text-sky-600',
    actionPlans: 'bg-sky-50 text-sky-600',
    openquestion: 'bg-emerald-50 text-emerald-600',
    open_question: 'bg-emerald-50 text-emerald-600',
  };

  const normalizedType = type?.toLowerCase();
  return colorMap[normalizedType] || colorMap[type] || 'bg-neutral-50 text-neutral-600';
};

export {
  PollIcon,
  QuizIcon,
  WordCloudIcon,
  QnAIcon,
  FeedbackIcon,
  ChallengesIcon,
  ActionPlansIcon,
  OpenQuestionIcon,
  DefaultIcon,
};
